import { AccountContextProvider } from './AccountContext';
import { LanguageContextProvider } from './LanguageContext';
import { NavigationContextProvider } from './NavigationContext';
import { ToastContextProvider } from './ToastContext';

const AppContexts = ({ children }) => (
  <AccountContextProvider>
    <ToastContextProvider>
      <NavigationContextProvider>
        <LanguageContextProvider>{children}</LanguageContextProvider>
      </NavigationContextProvider>
    </ToastContextProvider>
  </AccountContextProvider>
);

export default AppContexts;
